import { Card, Skeleton } from 'antd';
import { Flex } from '@react-css/flex';

export const RowLoader = ({ rows = 5, box = false }) => {

    const rowSkeletons = [...Array(rows).keys()].map((i) => (
        <Flex key={i} style={{ padding: ".5rem" }} justifyContent="space-between">
            <Flex width={"50%"} style={{ padding: "0 .8rem" }} justifyContent={"center"}>
                <Skeleton.Input style={{ height: "1.5rem", width: "15rem" }} />
            </Flex>
            <Flex width={"50%"} style={{ padding: "0 .8rem" }} justifyContent={"center"}>
                <Skeleton.Input style={{ height: "1.5rem", width: "15rem" }} />
            </Flex>
        </Flex>
    ));

    return (
        <Flex flexDirection={"column"}>
            {box ? (
                <Card bordered={false} style={{ padding: "10px", paddingTop: "0px", boxShadow: "none" }}>
                    {rowSkeletons}
                </Card>
            ) : (
                rowSkeletons
            )}
        </Flex>
    );
}
